import { render } from "./MsThOptionNumber.vue?vue&type=template&id=783a86aa"
import script from "./MsThOptionNumber.vue?vue&type=script&lang=js"
export * from "./MsThOptionNumber.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__